import {Loading} from "components/Loading/Loading";
import {OrderEventType, TicketDBType} from "data/types";
import {FC, useEffect, useState} from "react";
import {useGetEventTicketsQuery} from "store/api";
import RaffleTickets from "./RaffleTickets";
import NormalTickets from "./NormalTickets";
import SubscriptionTicket from "./SubscriptionTicket";

export interface EventTicketsProps {
  order: OrderEventType;
  orderId: string;
  isRaffle: boolean;
  type: string;
  subscriberImg?: string;
  locality?: string;
}

const EventTickets: FC<EventTicketsProps> = ({
  orderId,
  isRaffle,
  type,
  order,
  subscriberImg,
  locality,
}) => {
  const [tickets, setTickets] = useState<TicketDBType[]>([]);
  const [luckyNumbers, setLuckyNumbers] = useState<number[]>([]);
  const {data, error, isLoading} = useGetEventTicketsQuery(
    {
      orderId: orderId,
      status: false,
    },
    {skip: subscriberImg !== undefined}
  );
  useEffect(() => {
    if (data) {
      setTickets(data.ticketDB);
      if (isRaffle) {
        setLuckyNumbers(data.luckyNumber || []);
      }
    }
    if (error) {
      console.log("error", error);
    }
  }, [data, error]);
  return isLoading ? (
    <Loading />
  ) : (
    <div className="p-6 min-h-screen">
      {isRaffle && tickets && tickets.length > 0 ? (
        <RaffleTickets tickets={tickets} luckyNumbers={luckyNumbers} />
      ) : !isRaffle && tickets && tickets.length > 0 ? (
        <NormalTickets
          tickets={tickets}
          isSubscriber={type === "Abonado"}
          order={order}
        />
      ) : (
        order &&
        subscriberImg && (
          <SubscriptionTicket
            subscriberImg={subscriberImg}
            locality={locality!}
            numberSeat={(order as any).numberSeat}
          />
        )
      )}
    </div>
  );
};

export default EventTickets;
